import React, { Component } from 'react'
import DragDropFunctions from '../../../dragDropFunctions';

export default class Table2 extends Component {
    constructor(props) {
        super(props)

    }

    render() {

        var eleProps;
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(this.props.elementData.props, this.props.globalVariables, "table", this.props.localVariables)
        }

        if (this.props.elementData.content && this.props.elementData.content.editableType && this.props.elementData.content.editableType == "ArraySelect") {
            return <div dangerouslySetInnerHTML={{ __html: DragDropFunctions.generateHtmlFromJson(this.props.elementData, true, this.props.globalVariables, undefined, this.props.localVariables) }} ref="theEl" />
        }
        const children = React.Children.toArray(this.props.children)
        const rows = []
        const rest = []
        children.forEach((child) => {
            const typeName = child && child.type && (child.type.displayName || child.type.name)
            if (typeName === 'Tr') rows.push(child)
            else rest.push(child)
        })
        return (
            <table {...eleProps}>
                {rest}
                {rows.length > 0 && <tbody>{rows}</tbody>}
            </table>
        )

    }
}


